import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid2 } from '@mui/material';
import { useNavigate } from 'react-router';
import { FinalIcon, VersionIcon } from '../shared/components/AppIcons';

const useStyles = makeStyles({
  welcomeText: {
    height: '82px',
    fontSize: '36px',
  },
  container: {
    width: '293px',
    height: '196px',
    textAlign: 'center',
    borderRadius: '4px',
    cursor: 'pointer',
    border: '1px solid rgb(236, 229, 229)',
    '&:hover': {
      border: '1px solid #F67570',
      boxShadow: '0 4px 4px 0 rgba(246, 117, 112, 0.09)',
    },
  },
  info: {
    fontSize: '16px',
    color: '#939393',
  },
  icon: {
    fontSize: '26px !important',
  },
});

const ContentCreationDashboard: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleClick = (id: string) => {
    switch (id) {
      case 'preFinalFile':
        navigate('/dashboard/content-creation/pre-final-file');
        break;
      case 'finalFile':
        navigate('/dashboard/content-creation/final-file');
        break;
    }
  };

  return (
    <Grid2 container ml={2} mt={2} direction="column">
      <Grid2 className={classes.welcomeText} mb={2}>
        Content Creation
      </Grid2>
      <Grid2 container direction="row">
        <Grid2
          container
          direction="column"
          alignItems="flex-start"
          className={classes.container}
          mr={3}
          pt={3}
          onClick={() => handleClick('preFinalFile')}
        >
          <Grid2 ml={3} mb={3}>
            <VersionIcon className={classes.icon} />
          </Grid2>
          <Grid2 pl={3}>
            <span style={{ fontSize: '24px' }}>Pre-Final File</span>
          </Grid2>
          <Grid2 pl={3} className={classes.info}>
            <span>Versions</span>
          </Grid2>
        </Grid2>
        <Grid2
          container
          direction="column"
          alignItems="flex-start"
          className={classes.container}
          mr={3}
          pt={3}
          onClick={() => handleClick('finalFile')}
        >
          <Grid2 ml={3} mb={3}>
            <FinalIcon className={classes.icon} />
          </Grid2>
          <Grid2 pl={3}>
            <span style={{ fontSize: '24px' }}>Final File</span>
          </Grid2>
          <Grid2 pl={3} className={classes.info}>
            <span>Approved versions</span>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default ContentCreationDashboard;
